import React, { Component } from "react";
import PropTypes from "prop-types";

import { Mutation } from "react-apollo";
import { Fieldset } from "rbx";

import Section from "../Section";
import { EditFormButtonGroup } from "../inputs";

import {
  UPDATE_GL_MAIN_ACCOUNT_MUTATION,
  DELETE_GL_MAIN_ACCOUNT_MUTATION
} from "../../graphql/GLMainAccounts/GLMainAccounts.graphql";
import { ourToast as toast } from "../../utils";

import GLMainAccountForm from "./GLMainAccountForm";

class EditGLMainAccountForm extends Component {
  state = {
    MainAccountId: "",
    Description: "",
    TypeRecIdRef: "",
    Active: "",
    ...this.props.account
  };

  onChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  render() {
    const {
      CompanyId,
      MainAccountId,
      Description,
      TypeRecIdRef,
      Active
    } = this.state;
    const { onComplete } = this.props;
    return (
      <Mutation
        mutation={UPDATE_GL_MAIN_ACCOUNT_MUTATION}
        refetchQueries={["ALL_GL_MAIN_ACCOUNTS_QUERY"]}
        variables={{
          data: {
            CompanyId,
            MainAccountId,
            Description,
            TypeRecIdRef: parseInt(TypeRecIdRef),
            Active
          },
          where: {
            RecId: this.props.account ? this.props.account.RecId : null
          }
        }}
      >
        {(updateAccount, { loading, error }) => (
          <Section title="Edit Account">
            <form
              id="edit-account-form"
              onSubmit={async e => {
                e.preventDefault();
                try {
                  await updateAccount();
                  onComplete();
                  toast.success("Account updated successfully.");
                } catch (err) {
                  toast.error("Error updating Account.");
                }
              }}
            >
              <Fieldset disabled={loading}>
                <GLMainAccountForm
                  inputs={{
                    CompanyId,
                    MainAccountId,
                    Description,
                    TypeRecIdRef,
                    Active
                  }}
                  onChange={this.onChange}
                />
                <EditFormButtonGroup
                  deleteMutation={DELETE_GL_MAIN_ACCOUNT_MUTATION}
                  form="edit-account-form"
                  refetchQueries={["ALL_GL_MAIN_ACCOUNTS_QUERY"]}
                  variables={{ where: { RecId: this.props.account.RecId } }}
                  onComplete={onComplete}
                />
              </Fieldset>
            </form>
          </Section>
        )}
      </Mutation>
    );
  }
}

EditGLMainAccountForm.propTypes = {
  onComplete: PropTypes.func,
  account: PropTypes.object
};
export default EditGLMainAccountForm;
